import { useContext, useEffect, useRef, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';
import { PANEL_CONTENT_TYPES, slideOutPanelControl } from '../../../../../../../containers/TimelineEditor/slideout-panel/SlideoutPanel';

/***********
 * Color Picker Custom Field
 * I've been through colour picker hell with this!
 * 
 * There are some many scenarios where things can conflict, especially when we have multiple colour fields in our module list
 * which should be freely selectable without interfering with each other.
 * 
 * See the comment in the click handler below for details on the issue that solves.
 * 
 * I have to implement this colour picker field everywhere in the module list where a colour picker is needed,
 * at least then we are only dealing with one block of code that could potentially still have issues.
 * 
 * I'll clean this up when I'm happy it's stable.
 * 
 * - Carl Trelfa 02/Feb/2026
 */

const ColorPickerField = (props) => {
    // console.log("Rendering ColorPickerField with props:", props);

    const fieldData = props.fieldData;
    const isCustomField = fieldData.customFieldConfig ? true : false;
    // const moduleConfig = props.moduleConfig;
    // const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const currentValFromDB = getCustomisationValue(customisationVars, isCustomField ? fieldData?.customFieldConfig?.dataLink : fieldData?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null;
    const [currentValue, setCurrentValue] = useState(currentValFromDB ?? '#000000');
    useEffect(() => {
        setCurrentValue(currentValFromDB ?? '#000000');
        // setPrevColorValue(currentValFromDB);
        // slideOutPanelControl.refreshColourPicker(currentValFromDB, fieldData);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, currentValFromDB]);
    useEffect(() => {
        // slideOutPanelControl.panelState.onColourChanged = (c) => changeFieldValue(c, false);
        // slideOutPanelControl.panelState.onColourSelected = (c) => changeFieldValue(c, true);
        
        slideOutPanelControl.refreshColourPicker(currentValFromDB, fieldData);
        props?.forceUpdateComponent?.();
    }, [currentValFromDB]);
    const [prevColorValue, setPrevColorValue] = useState(currentValFromDB);
    const prevColorValueRef = useRef(currentValFromDB);
    useEffect(() => {
        prevColorValueRef.current = prevColorValue;
    }, [prevColorValue]);

    const changeFieldValue = (value, isFinalSelection = true) => {
        WORKING_ON_NODE_DATA.fieldData = fieldData;
        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
        // console.log("Custom color picker: Changing field value:", value, typeof value);
        let valChanged = changeStringFieldValue(customisationVars, isCustomField ? fieldData?.customFieldConfig : fieldData, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode, isFinalSelection, false, prevColorValueRef.current);
        // setCurrentValue(value);
        if (isFinalSelection) {
            setCurrentValue(value);
            setPrevColorValue(value);
        }
        // slideOutPanelControl.refreshColourPicker(value, fieldData);
        setTimeout(() => {
            props?.forceUpdateComponent?.();
        }, 10);
    }

    const colourPickerTitle = fieldData?.customFieldConfig?.customFieldLabel ?? props.colourPickerTitle ?? 'Color';
    const fieldTitle = fieldData?.customFieldConfig?.customFieldLabel ?? props.fieldTitle ?? 'Color';

    return (
        <>
            <div className={`v2-module-field-label${props.isEnabled === false ? ' disabled' : ''}`}>{fieldTitle}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: COLOUR_NAME_TO_COLOUR_HEX(currentValue, campaignContext.campaignData)}} />}
                value={currentValFromDB}
                fieldId={'fill-color'}
                enabled={true}
                editable={false}
                onChange={null}
                // onClick={() => {ShowColorPicker(currentValue, changeFieldValue, campaignContext.campaignData, colourPickerTitle, () => {}, () => {})}}
                onClick={
                    () => {
                        /******
                         * Had conflicts with multiple colour picker fields.
                         * 
                         * The scenario:
                         * 1. User opens colour picker for Field A
                         * 2. User changes colour, but doesn't confirm it yet (colours are confirmed when the user clicks outside the panel, an undo point is created at this time anmd a save is triggered)
                         * 3. While the panel is still open, user opens colour picker for Field B
                         * 4. Colour picker has now been told to deal with field B, but the click triggers a confirmation for field A, field A's colour gets applied to field B!
                         * 
                         * The solution:
                         * We add a short timeout before opening the colour picker for field B, allowing any pending confirmation clicks for field A to be processed first.
                         * 
                         * Not ideal, but seems to work reliably.
                         ******/
                        setTimeout(() => {
                            slideOutPanelControl.openColourPicker(currentValue, (c) => changeFieldValue(c, false), (c) => changeFieldValue(c, true), colourPickerTitle, fieldData);
                            setPrevColorValue(currentValue);
                        }, 10);
                    }
                }
                maxLength={7}
            />
        </>
    );
}

export default ColorPickerField;
